// extracted by mini-css-extract-plugin
module.exports = {"ViewDetails":"ApprovableBatchRepayment_ViewDetails__3jpZK"};